import { render, staticRenderFns } from "./SyGlassCard.vue?vue&type=template&id=2544957c&"
import script from "./SyGlassCard.vue?vue&type=script&lang=js&"
export * from "./SyGlassCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports